// css =>
import "../../BaseStructure.css";
import Styled from "./orderHistoryBox.module.css";

// icons =>
import TickIcon from "../../Assets/Icons/tick.png";

// type =>
import { ORDER_BOX_TYPE } from "./orderHistoryBoxType";

// react =>
import { useNavigate } from "react-router-dom";

// utils =>
import { slugify } from "../../utils/RemoveUrlSpace";

function OrderHistoryBox({ orderedItemKey, orderedItemName, orderedItemPic, orderedItemCode, orderedItemColor, orderItemCount, orderedItemPrice }: ORDER_BOX_TYPE) {
    const navigate = useNavigate();

    return(
        <div className={ Styled.ItemBox } data-aos="fade-up">
            <div className={`row ${ Styled.OrderInfoBox }`}>
                <div className={`col-1 ${ Styled.OrderCodeBox }`}>
                    <p>{ orderedItemKey }</p>
                </div>

                <div className={`col-10 ${ Styled.OrderBody }`}>
                    <div className="col-2" onClick={() => {
                        navigate(`/product-info/${ slugify(orderedItemName) }/${ orderedItemCode }`);
                    }}>
                        <img src={ orderedItemPic || "" } alt="itme picture" />
                    </div>
                    <div className="col-2">
                        <p>{ orderedItemName }</p>
                    </div>
                    <div className="col-2">
                        <p>{ orderedItemCode }</p>
                    </div>
                    <div className="col-2">
                        <div className={`col-12 ${ Styled.ColorBox }`} style={{ backgroundColor: orderedItemColor }}></div>
                    </div>
                    <div className="col-2">
                        <p>{ orderItemCount } عدد</p>
                    </div>
                    <div className="col-2">
                        <p>{ orderedItemPrice }</p>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.OrderKeyBox }`}>
                    <p>پرداخت شده</p>
                </div>
            </div>

            <div className={`row ${ Styled.OrderBoxFrameMobile }`}>
                <div className={`col-3 ${ Styled.PictureSectionFrame } `}>
                    <img src={ orderedItemPic || "" } alt="itme picture" />
                </div>

                <div className={`col-8 ${ Styled.ProductInfoSectionFrame } `}>
                    <div className={`row ${ Styled.ProductInfoSection } `}>
                        <div className="col-12">
                            <p>نام محصول : { orderedItemName }</p>
                        </div>

                        <div className="col-12">
                            <p>کد محصول : { orderedItemCode }</p>
                        </div>

                        <div className="col-6" style={{ float: 'right' }}>
                            <p>
                                تعداد : 
                                { orderItemCount }
                            </p>
                        </div>
                        <div className="col-6">
                            <p className={ Styled.ColorText }>رنگ : </p>
                            <div className={`${ Styled.ColorBoxMobile }`} style={{ backgroundColor: orderedItemColor }}></div>
                        </div>

                        <div className="col-12">
                            <p>قیمت : { orderedItemPrice }</p>
                        </div>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.TickSectionFrame } `}>
                    <div className="col-12">
                        <img src={ TickIcon } alt="Tick" />
                        <small>پرداخت شده</small>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderHistoryBox;
